import Vue from 'vue'
import App from './game-base.vue'

import 'normalize.css'

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
